import './style.css';
import { GameApp } from './game/GameApp';

document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
  <section class="game-shell">
    <header class="topbar">
      <div class="brand"><span class="brand-mark">PH</span><div><strong>PHERMON</strong><small>SWARM SIGNAL LAB</small></div></div>
      <div class="core-meter player"><span>YOU</span><div class="meter-track"><i id="player-health"></i></div><b id="player-health-text">100</b></div>
      <div class="match-clock" id="match-timer">7:00</div>
      <div class="core-meter ai"><b id="ai-health-text">100</b><div class="meter-track"><i id="ai-health"></i></div><span>AI</span></div>
      <div class="top-actions"><button id="sound-button" type="button">SOUND ON</button><button id="pause-button" type="button" aria-label="Pause">Ⅱ</button></div>
    </header>

    <div class="arena-wrap">
      <div id="canvas-host"></div>
      <div id="game-overlay" class="game-overlay">
        <div class="overlay-card">
          <span class="eyebrow">AUTONOMOUS SWARM TACTICS</span>
          <h1 id="overlay-title">SHAPE THE FIELD.<br />UNLEASH THE SWARM.</h1>
          <p id="overlay-text">Route your swarm through the Forge and Shield zones. Trap exposed units in Decay. Every surviving hit changes their size.</p>
          <div class="quick-guide"><span><i>▲</i>ARM</span><span><i>⬡</i>SHIELD</span><span><i>☣</i>DECAY</span></div>
          <button id="primary-action" type="button">Start simulation</button>
        </div>
      </div>
    </div>

    <footer class="control-dock">
      <div class="status-block"><span>DROP INVENTORY</span><strong id="status-line">4/7 CHARGES · Select a drop</strong></div>
      <div id="inventory" class="inventory" aria-label="Drop inventory"></div>
      <div class="delivery-panel" aria-label="Next drops">
        <div class="delivery-heading"><span class="delivery-label">NEXT DROP</span><strong id="delivery-timer">10.0s</strong></div>
        <div class="delivery-conveyor">
          <div id="next-drops" class="next-drops"></div>
        </div>
      </div>
      <div class="hint-block"><span>PLACE</span><strong>CLICK / TAP</strong><small>ESC cancels</small></div>
    </footer>
  </section>
`;

const game = new GameApp();
void game.init();
